<template>
  <div>
    <app-header title="Admin Alerts" />
    <loading-spinner v-if="!alerts" />
    <b-container class="mt-5" v-else>
      <b-row class="mt-5">
        <b-col>
          <b-table-simple striped>
            <b-thead>
              <b-tr>
                <b-th>Date</b-th>
                <b-th>Type</b-th>
                <b-th>Message</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="item in alerts" :key="item.id">
                <b-td>{{ item.created | moment("YYYY-MM-DD") }}</b-td>
                <b-td>{{ item.type }}</b-td>
                <b-td>{{ item.message }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    LoadingSpinner
  },

  data() {
    return {
      alerts: null,
    };
  },

  created() {
    this.refreshHistory();
  },

  methods: {
    async refreshHistory() {
      this.alerts = await $api.get('/v1/internal/adminalerts');
    },
  },
};
</script>
